import React, {useState, useEffect} from 'react'
import { faEnvelope, faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { displayEditorUtil } from '../../utils/topicUtils';

const ComponentItem = ({topic, obj, containerId, closeSelect}) => {

    const [hover, setHover] = useState(false);
    const [modal, setModal] = useState(false);

    function handleHover(state){
        setHover(state);
    };

    const showModal = ()=>{
        if(closeSelect != null){ closeSelect(); }
        setModal(true);
    }

    const closeModal = ()=>{
        setModal(false);
    }

    const styles = {
        item: {
            background: hover?'#efefef':'#fff',
            margin: '10px 5px',
            padding:'3px 15px',
            border:'1px solid #404040',
            borderRadius:30,
            alignItems: 'center',
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        title:{
            color: '#404040',
            fontSize: 15,
            marginBottom: 0
        },
    }

    const editorParams = {
        topic: topic,
        obj: null,
        componentType: obj.ComponentType,
        editor: obj.Editor,
        containerId: containerId,
        action: "insert",
        close: closeModal,
    }

    return (
        <>
            <Link onClick={showModal} style={styles.item} className='btn' onMouseEnter={()=>handleHover(true)} onMouseLeave={()=>handleHover(false)}>
                <div style={styles.title}>{obj.Title}</div>
            </Link>

            <Modal size='lg' show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{fontSize:15}}>{obj.Title} Editor</Modal.Title>
                    <button type="button" onClick={closeModal} className="close">&times;</button>
                </Modal.Header>
                <Modal.Body style={{padding:0}}>  
                    {displayEditorUtil(editorParams)}
                </Modal.Body> 
            </Modal>
        </>
    )
}

export default ComponentItem